import { Body1Strong, Card, Caption1, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

import { DASHBOARD_CARD_APPEARANCE_STYLE } from '../dashboard.styles';

const useStyles = makeStyles({
  panel: {
    ...DASHBOARD_CARD_APPEARANCE_STYLE,
    padding: tokens.spacingHorizontalL,
  },
  header: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    marginBottom: tokens.spacingVerticalL,
  },
  caption: {
    color: tokens.colorNeutralForeground3,
  },
});

type TProps = {
  title: string;
  caption?: string;
  children: ReactNode;
};

const DashboardChartPanel = ({ title, caption, children }: TProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.panel}>
      <div className={classes.header}>
        <Body1Strong>{title}</Body1Strong>
        {caption ? <Caption1 className={classes.caption}>{caption}</Caption1> : null}
      </div>
      {children}
    </Card>
  );
};

export default DashboardChartPanel;
